import React from 'react';
import { string } from 'prop-types';

import { NoContentContainer, NoContentMessage } from './no-content.style';

/**
 * No content helper component
 * @param {object} params - Object containing props
 * @param {string} params.message - Message to display
 * @return {element}
 */
const NoContent = ({ message }) => (
  <NoContentContainer>
    <NoContentMessage>{message}</NoContentMessage>
  </NoContentContainer>
);

NoContent.propTypes = {
  message: string.isRequired,
};

export default NoContent;
